import { render } from "./AssetComponent.vue?vue&type=template&id=e67876c4&scoped=true"
import script from "./AssetComponent.vue?vue&type=script&lang=js"
export * from "./AssetComponent.vue?vue&type=script&lang=js"

import "./AssetComponent.vue?vue&type=style&index=0&id=e67876c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e67876c4"]])

export default __exports__